import ExcelJS from "exceljs";

export default function sectionTableReport(tableData, headings, filename) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  const titleRow = sheet.getRow(1);
  titleRow.getCell(1).value = "SNO.";
  for (let i = 0; i <= headings.length; i++) {
    titleRow.getCell(i + 1).style = excelHeadingStyle;
    titleRow.getCell(i + 2).value = headings[i]?.title;

    const column = sheet.getColumn(i + 2);
    column.width = 30;
  }

  // Set header height
  sheet.getRow(1).height = 30;

  for (let i = 0; i < tableData?.length; i++) {
    const row = sheet.getRow(i + 2);
    row.getCell(1).value = i + 1;
    for (let j = 0; j < headings.length; j++) {
      if (headings[j]?.type == "array") {
        const arrayObject =
          headings[j]?.array?.find((data) => {
            if (headings[j].nested) {
              return data?.id == getObjectValue(tableData[i], headings[j]?.key);
            } else {
              return data?.id == tableData[i][headings[j]?.key];
            }
          }) || {};
        row.getCell(j + 2).value =
          arrayObject[headings?.arrayKey] || arrayObject?.name;
      } else if (headings[j]?.type == "function") {
        const functionValue = headings[j]?.function(
          getObjectValue(tableData[i], headings[j]?.key)
        );
        row.getCell(j + 2).value = functionValue;
      } else {
        row.getCell(j + 2).value =
          getObjectValue(tableData[i], headings[j]?.key) || "-";
      }
    }
  }

  // Generate the Excel file and initiate download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename ? `${filename}.xlsx` : "Report.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    +URL.revokeObjectURL(url);
  });
}

export const excelHeadingStyle = {
  alignment: { horizontal: "center", vertical: "middle" },
  fill: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
  },
  border: {
    top: { style: "thin", color: { argb: "FF000000" } }, // Black color
    left: { style: "thin", color: { argb: "FF000000" } },
    bottom: { style: "thin", color: { argb: "FF000000" } },
    right: { style: "thin", color: { argb: "FF000000" } },
  },
};

function getObjectValue(obj, key) {
  const keys = key.split(".");
  let value = obj;

  for (let k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = value[k];
    } else {
      return "-"; // Key doesn't exist in the object
    }
  }

  return value;
}
